import { getRequest, replaceInUrl, postRequest } from './index';
import apiEndpoints from './apiEndpoints';

export const connectACHBankAccountRequest = ({ ApplicationUid, data }) =>
  postRequest(
    replaceInUrl(apiEndpoints.bankAccounts.postBankAccount, {
      ApplicationUid,
    }),
    data,
  );

export const getBankAccountsRequest = ({ ApplicationUid }) =>
  getRequest(
    replaceInUrl(apiEndpoints.bankAccounts.getBankAccounts, {
      ApplicationUid,
    }),
  );
